module.exports = __webpack_public_path__ + "img/download-top-img.71388031.png";